import axios from "axios";
import {URL_BASE} from "@/configs/constants";

// Mudar rota
const RESOURCE = 'historic-dashboard-boxes';

export default {
    loadDashboardBoxHistorics(context, params) {
        context.commit('LOADER', true)
        return new Promise((resolve, reject) => {
            axios.get(`${URL_BASE}${RESOURCE}`, {params})
                .then(response => {
                    context.commit('LOAD_BOX_DASHBOARD', response.data)
                    return resolve(response.data)
                }).catch(errors => {
                return reject(errors)
            }).finally(() => context.commit('LOADER', false))
        })
    },


    loadDashboardHistoric(context, id) {
        context.commit('LOADER', true);
        return new Promise((resolve, reject) => {
          axios.get(`${URL_BASE}historic-dashboard-boxes-show/${id}`)
            .then(response => resolve(response.data))
            .catch((e) => reject(e))
            .finally(() => context.commit('LOADER', false));
        });
      }
}